import axios from '@axios'

const PREFIX = 'cnd-estaduais'

export default {

  getPaginado(page, pageSize, filtros) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`, filtros)
  },

  getURL(id) {
    return axios.get(`${PREFIX}/${id}/url`)
  },

  getObservacoes(id) {
    return axios.get(`${PREFIX}/${id}/observacao`)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },

  salvarObservacao(observacao) {
    return axios.post(`${PREFIX}/observacao/salvar`, observacao)
  },

  notificaCnd(nomeEmpresa, emailEmpresa, emailCc, id, mensagemAdicional, definirEmailPadrao) {
    return axios.put(`${PREFIX}/${id}/notifica?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional)}&definirEmailPadrao=${definirEmailPadrao}`)
  },

  baixaEmLote(filtros, nomeArquivo) {
    return axios.post(`${PREFIX}/baixa-lotes?nomeArquivo=${nomeArquivo}`, filtros)
  },

  baixarEmExcel(tipoCnd, filtros) {
    return axios.post(`${PREFIX}/${tipoCnd}/baixa-excel`, filtros)
  },

  deletarExcel(url, nomeArquivo) {
    axios.post(`${PREFIX}/deletar-excel?url=${url}&nomeArquivo=${nomeArquivo}`)
  },

  getTodasLinhas(filtros) {
    return axios.post(`${PREFIX}/allPaged`, filtros)
  },

  getHistorico(tipoCnd, id, filtros) {
    return axios.post(`${PREFIX}/historico?empresaId=${id}`, filtros)
  },

  baixarSelecionados(ids) {
    return axios.post(`${PREFIX}/baixar-selecionadas`, ids)
  },

  notificaHistorico(nomeEmpresa, emailEmpresa, emailCc, mensagemAdicional, definirEmailPadrao, ids) {
    return axios.post(`${PREFIX}/notifica-historico?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional)}&definirEmailPadrao=${definirEmailPadrao}`, ids)
  },

  GetUrlWhatsApp(ids) {
    return axios.post(`${PREFIX}/url-whatsapp`, ids)
  },

  baixarEmExcelEspecifico(dto) {
    return axios.post(`${PREFIX}/baixa-excel-selecionados`, dto)
  },
  getDocWhatsapp(id) {
    return axios.post(`${PREFIX}/url-whatsapp`, [id])
  },
}
